import apiClient from "./client.js";

export const submitFeedback = async (feedbackData) => {
  try {
    console.log('submitFeedback:', feedbackData);
    console.log("at address: ", `/api/v1/feedback`);
    const response = await apiClient.post(`/api/v1/feedback`, feedbackData);
     console.log('Feedback submitted:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error submitting feedback:', error);
    throw error;
  }
};
